import(/* webpackMode: "eager" */ "/home/ubuntu/shipsmart/apps/admin/src/app/error.tsx");
